import React from 'react';
import PropTypes from 'prop-types';
import { useListBox } from 'react-aria';
import ListBoxOption from './ListBoxOption';
import s from './ListBox.module.scss';
/**
 * A ListBox based on react-aria from Adobe
 * Taken from https://react-spectrum.adobe.com/react-aria/useComboBox.html
 * @param {object} props - component props
 * @returns {object} - component jsx
 */
function ListBox(props) {
  const ref = React.useRef();
  const { listBoxRef = ref, state, handleLoadMore } = props;
  const { listBoxProps } = useListBox({ ...props }, state, listBoxRef);

  const handleScroll = (e) => {
    const scrollOffset =
      e.currentTarget.scrollHeight - e.currentTarget.clientHeight * 2;
    if (e.currentTarget.scrollTop > scrollOffset) {
      handleLoadMore();
    }
  };

  return (
    <ul
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...listBoxProps}
      ref={listBoxRef}
      className={s.listBox}
      onScroll={handleScroll}
    >
      {[...state.collection].map((item) => (
        <ListBoxOption key={item.key} item={item} state={state} />
      ))}
    </ul>
  );
}

/* For detailed prop types see react-aria */
ListBox.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object.isRequired,
  listBoxRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
  handleLoadMore: PropTypes.func.isRequired,
};

export default ListBox;
